import React, { createContext, useContext } from 'react'

import useInnovaAuth from './useInnovaAuth'
import useWellList from './useWellList'
import useUserDatabaseAccess from 'components/common/hooks/useUserDatabaseAccess'

const WellListContext = createContext(null)

export const WellListProvider = ({ children }) => {
  const { getDatabaseOrg, getDefaultDatabaseOrg } = useInnovaAuth()
  const { hasMultiDbAccess } = useUserDatabaseAccess(false)
  const dbInUse = hasMultiDbAccess() ? getDatabaseOrg() : getDefaultDatabaseOrg()

  const value = useWellList(dbInUse)
  return <WellListContext.Provider value={value}>{children}</WellListContext.Provider>
}

export const useWellListContext = () => {
  const ctx = useContext(WellListContext)
  if (!ctx) throw new Error('useWellList must be used within a WellListProvider')
  return ctx
}

export default useWellListContext